import { useState } from 'react';

/** A failed tenant override restores safe bundled art; no remote image URLs are accepted. */
export function BrandingHeroImage({ overrideUrl, defaultUrl, alt = '', className }: {
  readonly overrideUrl?: string; readonly defaultUrl?: string; readonly alt?: string; readonly className?: string;
}) {
  const [failedUrls, setFailedUrls] = useState<ReadonlySet<string>>(() => new Set());
  const override = overrideUrl?.startsWith('blob:') && !failedUrls.has(overrideUrl) ? overrideUrl : undefined;
  const source = override ?? (defaultUrl && !failedUrls.has(defaultUrl) ? defaultUrl : undefined);
  if (!source) return null;
  return <img className={className} src={source} alt={override ? alt : ''} fetchPriority="high"
    onError={() => setFailedUrls((current) => new Set([...current, source]))} />;
}
